export enum APPLICATION_TYPE {
    DASHBOARD = 'dashboard',
    STARTUP_LIBRARY = 'startup-library'
}
